let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Jqwl0")).then(() => parcelRequire('j6t39'));